import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_4_1_7 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.7 Case 7</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="challenge_case_7"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 7. This is a positive case.
                Beginning at the level of the cerebellum and moving superiorly,
                we see the temporal and occipital regions, here. Distinct white
                matter tracts are identifiable on the left as well as on the
                right. Less intense activity in the surrounding gray matter is
                also seen. Therefore, there is preserved gray-white contrast
                throughout the temporal and occipital regions. This is in
                contrast to the frontal regions, identified here.
              </p>
              <p>
                Distinct white matter tracts are not easily identifiable on the
                left or on the right. There is an overall patchy appearance to
                the tracer distribution. In addition, there is loss of
                gray-white contrast throughout the frontal regions bilaterally.
              </p>
              <p>
                Continuing to move upwards and entering into the lower parietal
                region, distinct white matter tracts are not readily
                identifiable on the left or the right. In addition, on the
                left-hand side, intense activity is seen within the gray matter,
                extending to the cortical rim, as identified here. This pattern
                is also seen on the right-hand side, here.
              </p>
              <p>
                Reviewing the remainder of the slices in the parietal region
                also shows this to be true. There is loss of gray-white contrast
                in the parietal lobes. After reviewing all the slices, it is
                clear that there is loss of gray-white contrast in two regions.
                The parietal lobes and the frontal cortices bilaterally show
                loss of gray-white contrast, and therefore this case is
                positive. If you called this case negative, you may want to
                review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-6"
          nextLesson="/module-4/module-4-1-8"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1789471631&entry_id=1_ljkxmsyd&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_ljkxmsyd"
        />
      </main>
    </div>
  );
};

export default Module_4_1_7;
